{
  "title": "நோயாளர் கையளிப்பு (I-PASS)",
  "illnessSeverity": "நோய் தீவிரம்",
  "patientSummary": "நோயாளர் சுருக்கம்",
  "actionList": "செயல் பட்டியல்",
  "situationAwareness": "சூழ்நிலை விழிப்புணர்வு",
  "synthesis": "பெறுநரின் தொகுப்பு",
  "acknowledge": "கையளிப்பை ஒப்புக்கொள்",
  "severity": {
    "stable": "நிலையானது",
    "watcher": "கண்காணிப்பில்",
    "unstable": "நிலையற்றது"
  },
  "loading": "Loading handoffs…",
  "errorState": "Could not load handoffs.",
  "emptyState": "No handoffs waiting for you.",
  "unknownPatient": "Unknown patient",
  "from": "Handed over by {{name}}",
  "openChart": "Open chart",
  "notProvided": "Not provided",
  "noActions": "No actions listed.",
  "noContingency": "No contingency plan was given. Ask the outgoing clinician what to watch for.",
  "synthesisHint": "Read back what you understood. This is the step the protocol exists to force.",
  "synthesisPlaceholder": "In my own words, the plan is…",
  "acknowledgedAt": "Acknowledged {{when}}",
  "toast": {
    "acknowledged": "Handoff acknowledged",
    "acknowledgeFailed": "Could not acknowledge the handoff"
  },
  "ipass": {
    "illness": "I — Illness severity",
    "patientSummary": "P — Patient summary",
    "actionList": "A — Action list",
    "situationAwareness": "S — Situation awareness",
    "contingencyPlan": "S — Contingency plan",
    "synthesis": "S — Synthesis by receiver"
  }
}
